import { createFileRoute } from "@tanstack/react-router";

import PackingSlipSignature from "../-components/ShipMetal/PackingSlipSignature";

export const Route = createFileRoute("/_authenticated/trade/ship-metal/signature")({
  component: PackingSlipSignature,
  context: () => ({ permissions: "trade.ship" }),
});
